<template>
  <div class="grid grid-cols-1 gap-3">
    <InputField
      v-if="showLocationName"
      :id="`${prefix}-name`"
      v-model="localAddress.name"
      title="Location Name"
      placeholder="Location name"
      :disabled="disabled"
    />
    <InputField
      :id="`${prefix}-street`"
      v-model="localAddress.street"
      title="Street"
      placeholder="Street address"
      :disabled="disabled"
    />
    <InputField
      :id="`${prefix}-unit`"
      v-model="localAddress.unit"
      title="Unit / Suite"
      placeholder="Apt, suite, unit, etc."
      :disabled="disabled"
    />
    <div class="grid grid-cols-6 gap-3">
      <div class="col-span-2">
        <InputField
          :id="`${prefix}-city`"
          v-model="localAddress.city"
          title="City"
          placeholder="City"
          :disabled="disabled"
        />
      </div>
      <div class="col-span-2">
        <SelectInput
          :id="`${prefix}-state`"
          v-model="localAddress.state"
          label="State"
          placeholder="State"
          :options="STATE_OPTIONS"
          filter
          :disabled="disabled"
        />
      </div>
      <div class="col-span-2">
        <InputField
          :id="`${prefix}-zip`"
          v-model="localAddress.zip_code"
          title="Zip"
          placeholder="Zip code"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { STATE_OPTIONS } from "serviceshift-ui/shared/src/lib/stateOptions";
import { reactive, watch } from "vue";

import InputField from "@/components/Seranova/InputField/InputField.vue";
import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";

export interface EditableAddress {
  name?: string;
  street: string;
  unit: string;
  city: string;
  state: string;
  zip_code: string;
}

const props = withDefaults(
  defineProps<{
    modelValue: EditableAddress;
    prefix?: string;
    disabled?: boolean;
    showLocationName?: boolean;
  }>(),
  {
    prefix: "address",
    disabled: false,
    showLocationName: false
  }
);

const emit = defineEmits<{
  "update:modelValue": [value: EditableAddress];
}>();

const localAddress = reactive<EditableAddress>({ ...props.modelValue });

watch(
  () => props.modelValue,
  (val) => Object.assign(localAddress, val)
);

watch(localAddress, (val) => {
  emit("update:modelValue", { ...val });
});
</script>
